import { Component, ElementRef, OnInit, Renderer2, ViewChild, ChangeDetectorRef, Input, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingSpinnerService } from 'src/app/services/loading-spinner.service';
import flatpickr from 'flatpickr';
import { Timestamp } from 'firebase/firestore';
import { DateFormatterService } from 'src/app/services/date-formatter.service';
import { OrdersApiService, Birthday, Playground, Location, ReservedSlot, BirthdayData } from 'src/app/services/orders-api.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-orders-admin',
  templateUrl: './orders-admin.component.html',
  styleUrls: ['./orders-admin.component.scss']
})

export class OrdersAdminComponent implements OnInit, OnDestroy {

  @Input() businessId!: string;

  @ViewChild('backdrop') backdrop!: ElementRef;
  @ViewChild('orderExpand') orderExpand!: ElementRef;
  @ViewChild('birthdayToast') birthdayToast!: ElementRef;
  @ViewChild('birthdayDelete') birthdayDelete!: ElementRef;
  @ViewChild('cancelBirthdayModal') cancelBirthdayModal!: ElementRef;
  @ViewChild('cancelMessage') cancelMessage!: ElementRef<HTMLTextAreaElement>;
  @ViewChild('locationFilterDropdown') locationFilterDropdown!: ElementRef;
  @ViewChild('statusFilterDropdown') statusFilterDropdown!: ElementRef;

  today: string = '';
  selectedDate!: string;
  selectedDateForm!: string;
  selectedValue: string = '';
  addBirthdayForm!: FormGroup;
  birthdays: Array<any> = [];
  allLocations!: Array<any>;
  formLocations!: Array<any>;
  groupedData: any[] = [];
  deliveryDays!: number;
  selectedValueAdd: string = '';
  selectedDateAdd: string | null = null;
  selectedLocation: any;
  filteredRooms: any[] = [];
  filteredLocations: any[] = [];
  minDate: string = '';
  selectedRoom: any;
  reservedBirthdaysForm: Array<{ start: string; end: string }> = [];
  startTime: string = '';
  endTime: string = '';
  editMode!: boolean;
  birthdayCard !: any;
  isReserved: boolean = false;
  isReadOnly: boolean = false;
  cancellationReason!: string;
  funCityPlaygroundsIds: string[] = environment.funCityPlaygroundsIds;
  mpIds: string[] = [];
  managedPlaygrounds: any[] = [];
  selectedPlaygroundId: string = '';
  isFunCityPlayground: boolean = false;
  isGeneratingPaymentLink: boolean = false;
  cancelReason: string = '';
  // Location filter state
  allLocationsSelected: boolean = true;
  selectedLocationIds: string[] = [];
  tempSelectedLocationIds: string[] = [];
  locationSearchTerm: string = '';
  // Status filter state
  allStatusesSelected: boolean = true;
  selectedStatuses: string[] = [];
  tempSelectedStatuses: string[] = [];
  statusOptions = [
    { value: 'all', label: 'All' },
    { value: 'personalized', label: 'Personalized' },
    { value: 'reserved', label: 'Reserved' },
    { value: 'generic', label: 'Generic' },
    { value: 'cancelled', label: 'Cancelled' }
  ];
  /** Order status options for editable dropdown in edit form (Firestore orderStatus values). */
  orderStatusFormOptions: { value: string; label: string }[] = [
    { value: 'pending', label: 'Pending' },
    { value: 'in_progress', label: 'In progress' },
    { value: 'ready_to_ship', label: 'Ready to ship' },
    { value: 'order_completed', label: 'Order completed' },
    { value: 'waiting_confirmation', label: 'Reserved (waiting confirmation)' },
    { value: 'generic_magnet', label: 'Generic magnet' },
    { value: 'cancelled', label: 'Cancelled' },
  ];
  // Date and time picker implementation
  @ViewChild('startTimeInput') startTimeInput!: ElementRef;
  @ViewChild('endTimeInput') endTimeInput!: ElementRef;
  @ViewChild('dateInput') dateInput!: ElementRef;
  @ViewChild('dateInput2') dateInput2!: ElementRef;
  private flatpickrInstance!: flatpickr.Instance;
  private flatpickrInstance2!: flatpickr.Instance;
  filterMode: 'today' | 'range' | 'month' | 'range1' = 'today';
  selectedRange: { start: string; end: string } | null = null;
  selectedRangeText: string = '';
  private previousFilterMode: 'today' | 'range' | 'month' | 'range1' = 'today';

  constructor(
    private fb: FormBuilder,
    public loadingSpinnerService: LoadingSpinnerService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private dateFormatter: DateFormatterService,
    private ordersApi: OrdersApiService,
    private http: HttpClient
  ) {
    this.initForm();
    this.allStatusesSelected = true;
    this.tempSelectedStatuses = this.statusOptions
      .filter(s => s.value !== 'all')
      .map(s => s.value);
    this.selectedStatuses = [];
  }

  private initForm(): void {
    this.addBirthdayForm = this.fb.group({
      choice: ["", Validators.required],
      selectDateForm: ['', Validators.required],
      createdDateForm: [''],
      playground: [''],
      location: ['', Validators.required],
      room: ['', Validators.required],
      name: ['', Validators.required],
      age: ['', [Validators.required, Validators.min(0)]],
      numberOfKids: ['', Validators.required],
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
      orderNote: [''],
      orderStatus: [''],
      celebrantId: [''],
      adminStoryUrl: ['']
    });
  }

  get formControls(): { [key: string]: AbstractControl } {
    return this.addBirthdayForm.controls;
  }

  ngAfterViewInit() {
    this.flatpickrInstance2 = flatpickr(this.dateInput2.nativeElement, {
      dateFormat: 'Y-m-d',
      defaultDate: new Date(),
      minDate: this.minDate,
      disableMobile: true,
    });

    this.reinitTopDatepicker();

    flatpickr(this.startTimeInput.nativeElement, {
      enableTime: true,
      noCalendar: true,
      dateFormat: 'H:i',
      time_24hr: true,
      disableMobile: true,
    });

    flatpickr(this.endTimeInput.nativeElement, {
      enableTime: true,
      noCalendar: true,
      dateFormat: 'H:i',
      time_24hr: true,
      disableMobile: true,
    });
  }

  openCalendar() {
    if (this.filterMode === 'range' || this.filterMode === 'range1') {
      this.clearDateInput();
      this.reinitTopDatepicker();
      if (this.flatpickrInstance) {
        this.flatpickrInstance.open();
      }
    }
  }

  openCalendar2() {
    if (this.flatpickrInstance2) {
      this.flatpickrInstance2.open();
    }
  }

  onDateInputClick() {
    if (this.filterMode === 'range' || this.filterMode === 'range1') {
      this.clearDateInput();
      this.reinitTopDatepicker();
      if (this.flatpickrInstance) {
        this.flatpickrInstance.open();
      }
    }
  }

  onFilterModeChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    const newFilterMode = target.value as 'today' | 'range' | 'month' | 'range1';

    if (this.filterMode !== 'range') {
      this.previousFilterMode = this.filterMode;
    }

    this.filterMode = newFilterMode;
    this.cdr.detectChanges();

    if (this.filterMode === 'today') {
      this.selectedRange = null;
      this.selectedRangeText = '';
      this.selectedDate = this.today;
      this.getBirthdays(this.selectedDate);

    } else if (this.filterMode === 'month') {
      const now = new Date();
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      const startStr = this.dateFormatter.formatLocalDateForInput(startOfMonth);
      const endStr = this.dateFormatter.formatLocalDateForInput(endOfMonth);

      this.selectedRange = { start: startStr, end: endStr };
      this.selectedRangeText = `${startStr} to ${endStr}`;
      this.getBirthdaysRange(startStr, endStr);
    }
    else if (this.filterMode === 'range1') {
      setTimeout(() => this.openCalendar());
      return;
    } else if (this.filterMode === 'range') {
      if (this.selectedRange && this.selectedRangeText) {
        this.getBirthdaysRange(this.selectedRange.start, this.selectedRange.end);
      } else {
        setTimeout(() => this.resetCustomRange());
      }
    }
    this.reinitTopDatepicker();
  }

  private reinitTopDatepicker() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
      this.flatpickrInstance = null as any;
    }

    const options: any = {
      dateFormat: 'Y-m-d',
      disableMobile: true,
    };

    if (this.filterMode === 'range' || this.filterMode === 'range1') {
      options.mode = 'range';

      options.onChange = (selectedDates: Date[], dateStr: string) => {
        if (selectedDates.length === 2) {
          const [start, end] = selectedDates;
          const startStr = this.dateFormatter.formatLocalDateForInput(start);
          const endStr = this.dateFormatter.formatLocalDateForInput(end);

          this.selectedRange = { start: startStr, end: endStr };
          this.selectedRangeText = this.dateFormatter.formatRangeForDisplay(start, end);

          this.filterMode = 'range';
          this.cdr.detectChanges();

          this.getBirthdaysRange(startStr, endStr);

          if (this.flatpickrInstance) {
            this.flatpickrInstance.close();
          }
        }
      };

      options.onOpen = () => {
        this.clearDateInput();
      };

      options.onClose = (selectedDates: Date[]) => {
        if (this.filterMode === 'range1') {
          if (selectedDates.length < 2) {
            this.revertToPreviousSelection();
            this.cdr.detectChanges();
          }
        }
      };

      if (this.dateInput?.nativeElement) {
        this.dateInput.nativeElement.value = '';
      }

      options.allowInput = false;
      options.clickOpens = true;
    } else {
      options.defaultDate = new Date();
    }

    this.flatpickrInstance = flatpickr(this.dateInput.nativeElement, options);
  }

  private clearDateInput() {
    if (this.dateInput?.nativeElement) {
      this.dateInput.nativeElement.value = '';
    }
    this.selectedRange = null;
    this.selectedRangeText = '';
  }

  resetCustomRange() {
    if (this.filterMode === 'range') {
      this.clearDateInput();
      this.reinitTopDatepicker();
      if (this.flatpickrInstance) {
        this.flatpickrInstance.open();
      }
    }
  }

  revertToPreviousSelection() {
    this.filterMode = this.previousFilterMode;
    this.selectedRange = null;
    this.selectedRangeText = '';
    this.cdr.detectChanges();
    if (this.previousFilterMode === 'today') {
      this.selectedDate = this.today;
      this.getBirthdays(this.selectedDate);
    } else if (this.previousFilterMode === 'month') {
      const now = new Date();
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const startStr = this.dateFormatter.formatLocalDateForInput(startOfMonth);
      const endStr = this.dateFormatter.formatLocalDateForInput(now);
      this.selectedRange = { start: startStr, end: endStr };
      this.selectedRangeText = `${startStr} to ${endStr}`;
      this.getBirthdaysRange(startStr, endStr);
    }
    this.reinitTopDatepicker();
  }

  goToSelection(selection: 'today' | 'month') {
    this.previousFilterMode = this.filterMode;
    this.filterMode = selection;
    this.cdr.detectChanges();

    if (selection === 'today') {
      this.selectedRange = null;
      this.selectedRangeText = '';
      this.selectedDate = this.today;
      this.getBirthdays(this.selectedDate);
    } else if (selection === 'month') {
      const now = new Date();
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const startStr = this.dateFormatter.formatLocalDateForInput(startOfMonth);
      const endStr = this.dateFormatter.formatLocalDateForInput(now);
      this.selectedRange = { start: startStr, end: endStr };
      this.selectedRangeText = `${startStr} to ${endStr}`;
      this.getBirthdaysRange(startStr, endStr);
    }
    this.reinitTopDatepicker();
  }

  selectOption(value: string) {
    this.selectedValue = value;
  }

  toggleBackdrop(show: boolean): void {
    if (show) {
      if (!this.editMode) {
        this.resetFormState();
      }
      this.backdrop.nativeElement.style.display = 'block';
    } else {
      this.resetFormState();
      this.backdrop.nativeElement.style.display = 'none';
    }
  }

  private resetFormState(): void {
    this.selectedValue = '';
    this.addBirthdayForm.reset({
      orderNote: '',
      celebrantId: '',
      createdDateForm: '',
      adminStoryUrl: '',
    });
    this.reservedBirthdaysForm = [];
    this.editMode = false;
    this.isReserved = false;
    this.isReadOnly = false;
    this.cancellationReason = '';
    if (this.managedPlaygrounds.length !== 1) {
      this.selectedPlaygroundId = '';
    }
    this.selectedRoom = null;
    this.filteredRooms = [];
    this.addBirthdayForm.patchValue({
      location: '',
      room: ''
    });
    this.addBirthdayForm.enable({ emitEvent: false });
    if (this.formLocations && this.formLocations.length === 1) {
      const onlyLocation = this.formLocations[0];
      this.selectedLocation = onlyLocation.id;
      this.addBirthdayForm.patchValue({ location: this.selectedLocation });
      this.filteredRooms = onlyLocation.rooms || [];
      if (this.filteredRooms.length >= 1) {
        this.selectedRoom = this.filteredRooms[0].id;
        this.addBirthdayForm.patchValue({ room: this.selectedRoom });
      } else {
        this.selectedRoom = null;
      }
      this.getReservedBirthdaysForm();
    }
  }

  onDateChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (this.filterMode === 'today') {
      this.loadingSpinnerService.show();
      this.selectedDate = input.value;
      this.getBirthdays(this.selectedDate);
    } else {
      const parts = input.value.split(' to ');
      if (parts.length === 2 && parts[0] && parts[1]) {
        this.loadingSpinnerService.show();
        this.selectedRange = { start: parts[0], end: parts[1] };
        this.selectedRangeText = input.value;
        this.getBirthdaysRange(parts[0], parts[1]);
      }
    }
  }

  getBirthdays(date: string) {
    this.ordersApi.getBirthdaysByCreatedDate(date).subscribe({
      next: (birthdays: Birthday[]) => {
        this.birthdays = birthdays;
        this.groupedData = [];

        if (this.birthdays.length > 0) {
          setTimeout(() => {
            this.groupData();
          }, 500);
        }
      },
      error: (error) => {
        console.error('Error fetching Birthdays:', error);
      }
    });
  }

  getBirthdaysRange(startDate: string, endDate: string) {
    this.ordersApi.getBirthdaysRangeByCreatedDate(startDate, endDate).subscribe({
      next: (birthdays: Birthday[]) => {
        this.birthdays = birthdays;
        this.groupedData = [];

        if (this.birthdays.length > 0) {
          setTimeout(() => {
            this.groupData();
          }, 500);
        }
      },
      error: (error) => {
        console.error('Error fetching Birthdays (range):', error);
      }
    });
  }

  getManagedPlaygrounds() {
    this.ordersApi.getManagedPlaygrounds().subscribe({
      next: (playgrounds: Playground[]) => {
        this.managedPlaygrounds = playgrounds;
        this.calculateMagnetsCount();
        if (this.managedPlaygrounds.length === 1) {
          this.handlePlaygroundChange(this.managedPlaygrounds[0].uid);
        }
      },
      error: (error) => {
        console.error('Error fetching managed playgrounds:', error);
      }
    });
  }

  handlePlaygroundChange(playgroundId: string): void {
    const selectedPlayground = this.managedPlaygrounds.find(p => p.uid === playgroundId);
    if (selectedPlayground) {
      this.selectedPlaygroundId = selectedPlayground.uid;
      this.selectedLocation = null;
      this.selectedRoom = null;
      this.formLocations = [];
      this.filteredRooms = [];
      this.addBirthdayForm.patchValue({
        playground: playgroundId
      });
      this.getLocationsForPlayground(playgroundId);
      this.getDeliveryDays();
    }
  }

  getLocationsForPlayground(playgroundId: string, onLoaded?: (locations: Location[]) => void) {
    this.ordersApi.getLocationsForPlayground(playgroundId).subscribe({
      next: (locations: Location[]) => {
        this.formLocations = locations;
        if (this.formLocations.length === 1) {
          this.handleLocationChange(this.formLocations[0].id);
        }
        onLoaded?.(locations);
      },
      error: (error) => {
        console.error('Error getting locations for playground:', error);
        this.formLocations = [];
      }
    });
  }

  getLocations() {
    this.ordersApi.getLocations().subscribe({
      next: (locations: Location[]) => {
        this.allLocations = locations;
        if (this.allLocationsSelected && this.allLocations.length > 0) {
          this.tempSelectedLocationIds = this.allLocations.map(l => l.id);
          this.selectedLocationIds = [...this.tempSelectedLocationIds];
        }
        this.calculateMagnetsCount();
      },
      error: (error) => {
        console.error('Error fetching locations:', error);
      }
    });
  }

  getDeliveryDays() {
    if (!this.selectedPlaygroundId) {
      return;
    }

    this.ordersApi.getDeliveryDays(this.selectedPlaygroundId).subscribe({
      next: (deliveryDays: number) => {
        this.deliveryDays = deliveryDays;
      },
      error: (error) => {
        console.error('Error fetching delivery days:', error);
        this.deliveryDays = 0;
      }
    });
  }

  groupData() {
    const dateMap = new Map<string, any[]>();
    for (const b of this.birthdays) {
      const created = b.createdDate ? new Date(b.createdDate) : new Date(b.startTime);
      const dateObj = created;
      const dateKey = dateObj.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });

      if (!dateMap.has(dateKey)) dateMap.set(dateKey, []);
      dateMap.get(dateKey)!.push(b);
    }

    const sortedDateKeys = Array.from(dateMap.keys()).sort((a, b) => {
      return new Date(b).getTime() - new Date(a).getTime();
    });

    this.groupedData = sortedDateKeys.map(dateKey => {
      const birthdaysForDate = dateMap.get(dateKey) || [];
      const locationMap = new Map<string, any[]>();
      birthdaysForDate.forEach(b => {
        const locId = b.locationId;
        if (!locationMap.has(locId)) locationMap.set(locId, []);
        locationMap.get(locId)!.push(b);
      });

      let locationsForDate = Array.from(locationMap.entries())
        .map(([locId, bs]) => {
          const loc = this.allLocations.find(l => l.id === locId);
          if (!loc) {
            return null;
          }

          // Resolve playground name from managedPlaygrounds using location.playgroundId
          const playground = this.managedPlaygrounds?.find(p => p.uid === loc.playgroundId);
          const playgroundName = playground?.fullName ?? playground?.name ?? 'Unknown playground';

          // Apply country ISO filter by playground (user_clients), not appointment/location
          const filteredBs =
            this.selectedIso === 'all'
              ? bs
              : bs.filter((b: any) => this.getPlaygroundIso(b.playgroundId) === this.selectedIso);
          if (filteredBs.length === 0) {
            return null;
          }

          const enriched = filteredBs
            .map(birthday => ({
              ...birthday,
              roomName: loc.rooms.find((room: { id: any; }) => room.id === birthday.roomId)?.name || 'Unknown Room'
            }))
            .filter(birthday => this.matchesStatusFilter(birthday))
            .sort((a: any, b: any) => {
              const aCreated = a.createdDate ? new Date(a.createdDate).getTime() : new Date(a.startTime).getTime();
              const bCreated = b.createdDate ? new Date(b.createdDate).getTime() : new Date(b.startTime).getTime();
              return bCreated - aCreated;
            });
          return {
            id: locId,
            name: loc.name,
            playgroundName,
            birthdays: enriched
          };
        })
        .filter((x: any) => !!x)
        .sort((a: any, b: any) => a.name.localeCompare(b.name));

      if (!this.allLocationsSelected && this.selectedLocationIds.length > 0) {
        locationsForDate = locationsForDate.filter((l: any) => this.selectedLocationIds.includes(l.id));
      }

      return {
        date: dateKey,
        locations: locationsForDate
      };
    });
    this.loadingSpinnerService.hide();
  }

  handleLocationChange(locationId: string): void {
    if (!this.formLocations?.length) return;
    const selectedLocation = this.formLocations.find(l => l.id === locationId);

    if (selectedLocation) {
      this.selectedLocation = selectedLocation;
      this.filteredRooms = selectedLocation.rooms || [];
      this.selectedRoom = null;
      this.addBirthdayForm.patchValue({
        location: locationId,
        room: ''
      });
      if (this.filteredRooms.length === 1) {
        this.handleRoomChange(this.filteredRooms[0].id);
      }
    }
  }

  handleRoomChange(roomId: string): void {
    if (!this.filteredRooms?.length) return;
    this.selectedRoom = this.filteredRooms.find(r => r.id === roomId);

    if (this.selectedRoom) {
      this.addBirthdayForm.patchValue({
        room: roomId
      });
      this.getReservedBirthdaysForm();
    }
  }

  onPlaygroundChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const selectedPlaygroundId = target.value;
    this.handlePlaygroundChange(selectedPlaygroundId);
  }

  onLocationChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const selectedLocationId = target.value;
    this.handleLocationChange(selectedLocationId);
  }

  onRoomChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const selectedRoomId = target.value;
    this.handleRoomChange(selectedRoomId);
  }

  getReservedBirthdaysForm() {
    const selectedDate = this.addBirthdayForm.get('selectDateForm')?.value;
    const location = this.addBirthdayForm.get('location')?.value;
    const room = this.addBirthdayForm.get('room')?.value;

    if (!selectedDate || !location || !room) {
      return;
    }
    if (!this.selectedPlaygroundId) {
      return;
    }

    this.ordersApi.getReservedSlots(this.selectedPlaygroundId, location, room, selectedDate).subscribe({
      next: (reservedSlots: ReservedSlot[]) => {
        this.reservedBirthdaysForm = reservedSlots;
      },
      error: (error) => {
        console.error('Error fetching Reserved Birthdays:', error);
        this.reservedBirthdaysForm = [];
      }
    });
  }

  private refreshData(): void {
    if (this.filterMode === 'today') {
      this.getBirthdaysRange(this.selectedDate, this.selectedDate);
    } else if (this.filterMode === 'month' || this.filterMode === 'range') {
      const startDate = this.selectedRange?.start || this.today;
      const endDate = this.selectedRange?.end || this.today;
      this.getBirthdaysRange(startDate, endDate);
    }
  }

  onStartTimeChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.startTime = input.value;
    const [startHours, startMinutes] = this.startTime.split(':').map(Number);
    const endDate = new Date();
    endDate.setHours(startHours + 2, startMinutes, 0);
    const formattedEndTime = `${endDate.getHours().toString().padStart(2, '0')}:${endDate.getMinutes().toString().padStart(2, '0')}`;
    this.addBirthdayForm.patchValue({
      startTime: this.startTime,
      endTime: formattedEndTime
    });
    this.endTime = formattedEndTime;
  }

  onEndTimeChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.endTime = input.value;
    this.addBirthdayForm.patchValue({
      endTime: this.endTime
    });
  }

  isTimeConflict(): boolean {
    const startTimeInMinutes = this.getMinutes(this.startTime);
    const endTimeInMinutes = this.getMinutes(this.endTime);

    return this.reservedBirthdaysForm.some(birthday => {
      const reservedStart = this.getMinutes(birthday.start);
      const reservedEnd = this.getMinutes(birthday.end);

      return (
        (startTimeInMinutes >= reservedStart && startTimeInMinutes < reservedEnd) ||
        (endTimeInMinutes > reservedStart && endTimeInMinutes <= reservedEnd) ||
        (startTimeInMinutes <= reservedStart && endTimeInMinutes >= reservedEnd)
      );
    });
  }

  private getMinutes(time: string): number {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }

  bookBirthday() {
    if (!this.selectedPlaygroundId) {
      this.showToast('Please select a playground first', 'error');
      return;
    }

    this.loadingSpinnerService.show();

    const startDateTime = this.dateFormatter.combineDateAndTime(this.addBirthdayForm.get('selectDateForm')?.value, this.editMode ? this.addBirthdayForm.get('startTime')?.value : this.startTime);
    const endDateTime = this.dateFormatter.combineDateAndTime(this.addBirthdayForm.get('selectDateForm')?.value, this.editMode ? this.addBirthdayForm.get('endTime')?.value : this.endTime);
    const orderStatus = this.orderStatus();

    if (this.editMode) {
      const updateData: Partial<BirthdayData> = {
        birthdayName: this.addBirthdayForm.get("name")?.value.trim(),
        birthdayYears: this.addBirthdayForm.get("age")?.value,
        numberOfMagnets: this.addBirthdayForm.get("numberOfKids")?.value,
        note: this.addBirthdayForm.get("orderNote")?.value,
        adminStoryUrl: this.addBirthdayForm.get("adminStoryUrl")?.value,
        startTime: Timestamp.fromDate(new Date(startDateTime)),
        endTime: Timestamp.fromDate(new Date(endDateTime)),
        locationId: this.addBirthdayForm.get("location")?.value,
        roomId: this.addBirthdayForm.get("room")?.value,
        services: [this.addBirthdayForm.get("choice")?.value === 'male' ? environment.serviceIds.MALE_ID : environment.serviceIds.FEMALE_ID],
      };
      const createdDateFormVal = this.addBirthdayForm.get("createdDateForm")?.value;
      if (createdDateFormVal) {
        updateData.createdDate = Timestamp.fromDate(new Date(createdDateFormVal));
      }
      const orderStatusVal = this.addBirthdayForm.get("orderStatus")?.value;
      if (orderStatusVal) {
        updateData.orderStatus = orderStatusVal;
      }
      const celebrantId = this.addBirthdayForm.get("celebrantId")?.value?.trim();
      if (celebrantId !== undefined && celebrantId !== null) {
        updateData.celebrantId = celebrantId;
      }

      this.ordersApi.updateBirthday(this.birthdayCard.id, updateData).subscribe({
        next: () => {
          this.selectedDate = this.addBirthdayForm.get("selectDateForm")?.value;
          this.refreshData();
          this.showToast("Birthday updated successfully!");
          const collapseElement = this.orderExpand.nativeElement;
          setTimeout(() => {
            this.renderer.addClass(collapseElement, 'collapsing');
            this.renderer.removeClass(collapseElement, 'collapse');
            this.renderer.removeClass(collapseElement, 'show');
            this.toggleBackdrop(false);
          }, 350);
        },
        error: (error) => {
          this.showToast('Error updating birthday', 'error');
        },
        complete: () => {
          this.loadingSpinnerService.hide();
        }
      });
    } else {
      const birthdayData: BirthdayData = {
        birthdayName: this.addBirthdayForm.get("name")?.value.trim(),
        birthdayYears: this.addBirthdayForm.get("age")?.value,
        numberOfMagnets: this.addBirthdayForm.get("numberOfKids")?.value,
        note: this.addBirthdayForm.get("orderNote")?.value,
        adminStoryUrl: this.addBirthdayForm.get("adminStoryUrl")?.value,
        startTime: Timestamp.fromDate(new Date(startDateTime)),
        endTime: Timestamp.fromDate(new Date(endDateTime)),
        locationId: this.addBirthdayForm.get("location")?.value,
        roomId: this.addBirthdayForm.get("room")?.value,
        orderStatus: orderStatus,
        playgroundId: this.selectedPlaygroundId,
        createdDate: Timestamp.fromDate(new Date()),
        email: "email@email.com",
        number: "0800 123 123",
        services: [this.addBirthdayForm.get("choice")?.value === 'male' ? environment.serviceIds.MALE_ID : environment.serviceIds.FEMALE_ID],
        uid: '',
        orgId: this.businessId,
        savedLocallyByUser: false,
        deliveryAddress: '',
        organizationName: '',
        staffId: environment.staffId
      };

      this.ordersApi.createBirthday(birthdayData).subscribe({
        next: (docId) => {
          this.ordersApi.updateBirthday(docId, { uid: docId }).subscribe({
            next: () => {
              this.selectedDate = this.addBirthdayForm.get("selectDateForm")?.value;
              this.resetFormState();
              this.refreshData();
              this.showToast("Birthday created successfully!");
              const collapseElement = this.orderExpand.nativeElement;
              setTimeout(() => {
                this.renderer.addClass(collapseElement, 'collapsing');
                this.renderer.removeClass(collapseElement, 'collapse');
                this.renderer.removeClass(collapseElement, 'show');
                this.toggleBackdrop(false);
              }, 350);
            },
            error: (error) => {
              this.showToast('Error updating birthday with UID', 'error');
            }
          });
        },
        error: (error) => {
          this.showToast('Error creating birthday', 'error');
        },
        complete: () => {
          this.loadingSpinnerService.hide();
        }
      });
    }
  }

  private orderStatus() {
    if (this.isFunCityPlayground && !this.editMode) {
      return 'waiting_confirmation';
    }

    const now = new Date().getTime();
    const selectedDateValue = this.addBirthdayForm.get('selectDateForm')?.value;
    const selectedDate = new Date(selectedDateValue).getTime();
    const differenceInDays = Math.ceil((selectedDate - now) / (1000 * 60 * 60 * 24));
    const orderStatus = differenceInDays > this.deliveryDays ? 'pending' : 'generic_magnet';
    if (this.editMode && this.birthdayCard?.orderStatus === 'waiting_confirmation') {
      const formOrderStatus = this.addBirthdayForm.get('orderStatus')?.value;
      if (formOrderStatus === 'confirmed') {
        return orderStatus;
      }
      return 'waiting_confirmation';
    }
    return orderStatus;
  }

  private showToast(message: string, type: 'success' | 'error' = 'success') {
    const el = this.birthdayToast.nativeElement as HTMLElement;
    el.textContent = message;
    el.classList.remove('text-bg-success', 'text-bg-danger');
    el.classList.add(type === 'success' ? 'text-bg-success' : 'text-bg-danger');
    el.classList.add('show');
    setTimeout(() => {
      el.classList.remove('show');
    }, 3000);
  }

  expandFormWithCardData(card: any) {
    const canEdit = true;
    this.isReadOnly = !canEdit;
    this.editMode = true;
    this.birthdayCard = card;
    this.selectedValue = card.services[0] === environment.serviceIds.MALE_ID ? 'male' : 'female';
    const date = this.dateFormatter.formatLocalDateForInput(new Date(card.startTime));
    this.isReserved = card.orderStatus === 'waiting_confirmation';
    this.getLocationsForPlayground(card.playgroundId, () => {
      this.handleLocationChange(card.locationId);
      this.handleRoomChange(card.roomId);
    });

    const createdDateStr = card.createdDate
      ? this.dateFormatter.formatLocalDateForInput(new Date(card.createdDate))
      : '';
    this.addBirthdayForm.patchValue({
      choice: this.selectedValue,
      name: card.birthdayName,
      age: card.birthdayYears,
      selectDateForm: date,
      createdDateForm: createdDateStr,
      playground: card.playgroundId,
      location: card.locationId,
      room: card.roomId,
      numberOfKids: card.numberOfMagnets,
      startTime: this.dateFormatter.formatTime(card.startTime),
      endTime: this.dateFormatter.formatTime(card.endTime),
      orderNote: card.note,
      orderStatus: card.orderStatus ?? '',
      celebrantId: card.celebrantId ?? '',
      adminStoryUrl: card.adminStoryUrl ?? ''
    });

    if (this.managedPlaygrounds.length > 1) {
      const playgroundMeta = this.managedPlaygrounds.find(p => p.uid === card.playgroundId);
      if (playgroundMeta && playgroundMeta.businessId) {
        this.selectedPlaygroundId = playgroundMeta.businessId;
        this.isFunCityPlayground = this.funCityPlaygroundsIds.includes(this.selectedPlaygroundId);
      }
    }

    this.addBirthdayForm.enable({ emitEvent: false });

    this.expandForm();
  }

  deleteCard() {
    this.loadingSpinnerService.show();

    this.ordersApi.deleteBirthday(this.birthdayCard.id).subscribe({
      next: () => {
        const collapseElement = this.orderExpand.nativeElement;
        setTimeout(() => {
          this.renderer.addClass(collapseElement, 'collapsing');
          this.renderer.removeClass(collapseElement, 'collapse');
          this.renderer.removeClass(collapseElement, 'show');
          const modalBackdrop = document.querySelector('.modal-backdrop.show');
          if (modalBackdrop) {
            modalBackdrop.classList.remove('show');
          }
          this.toggleBackdrop(false);
        }, 350);
        this.birthdayDelete.nativeElement.classList.remove('show');
        this.showToast("Birthday deleted successfully!");
        this.refreshData();
      },
      error: (error) => {
        this.showToast('Error deleting birthday', 'error');
      },
      complete: () => {
        this.loadingSpinnerService.hide();
      }
    });
  }

  cancelBirthday(birthdayId: string) {
    const reason = this.cancelReason.trim();
    if (!reason) {
      this.showToast('Please provide a cancellation reason', 'error');
      return;
    }

    this.loadingSpinnerService.show();

    this.ordersApi.cancelBirthday(birthdayId, reason).subscribe({
      next: () => {
        const collapseElement = this.orderExpand.nativeElement;
        setTimeout(() => {
          this.renderer.addClass(collapseElement, 'collapsing');
          this.renderer.removeClass(collapseElement, 'collapse');
          this.renderer.removeClass(collapseElement, 'show');
          const modalBackdrop = document.querySelector('.modal-backdrop.show');
          if (modalBackdrop) {
            modalBackdrop.classList.remove('show');
          }
          this.toggleBackdrop(false);
        }, 350);
        this.cancelBirthdayModal.nativeElement.classList.remove('show');
        this.showToast("Birthday cancelled successfully!");
        this.refreshData();
      },
      error: (error) => {
        this.showToast('Error cancelling birthday', 'error');
      },
      complete: () => {
        this.loadingSpinnerService.hide();
      }
    });
  }

  expandForm() {
    const collapseElement = this.orderExpand.nativeElement;

    if (!collapseElement.classList.contains('show')) {
      this.renderer.addClass(collapseElement, 'collapsing');
      this.renderer.removeClass(collapseElement, 'collapse');

      setTimeout(() => {
        this.renderer.removeClass(collapseElement, 'collapsing');
        this.renderer.addClass(collapseElement, 'collapse');
        this.renderer.addClass(collapseElement, 'show');

        this.toggleBackdrop(true);
      }, 350);
    }
  }

  ngOnInit(): void {
    this.mpIds = JSON.parse(localStorage.getItem('mp') || '[]');

    this.ordersApi.initialize(this.mpIds, this.businessId);

    this.formControls['selectDateForm'].valueChanges.subscribe((selectedDate) => {
      if (selectedDate) {
        this.getReservedBirthdaysForm();
      }
    });

    const currentDate = new Date();
    this.today = this.dateFormatter.formatLocalDateForInput(currentDate);
    this.selectedDate = this.today;
    this.minDate = this.dateFormatter.formatLocalDateForInput(new Date());

    this.getManagedPlaygrounds();
    this.getLocations();

    this.funCityPlaygroundsIds.includes(this.businessId) ? this.isFunCityPlayground = true : false;

    this.getBirthdays(this.selectedDate);
  }

  ngOnDestroy() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
    }
    if (this.flatpickrInstance2) {
      this.flatpickrInstance2.destroy();
    }
  }

  toggleAllLocations(selected: boolean) {
    this.allLocationsSelected = selected;
    if (selected) {
      this.tempSelectedLocationIds = this.allLocations.map(l => l.id);
    } else {
      this.tempSelectedLocationIds = [];
    }
  }

  toggleLocationSelection(locationId: string, selected: boolean) {
    if (selected) {
      if (!this.tempSelectedLocationIds.includes(locationId)) {
        this.tempSelectedLocationIds = [...this.tempSelectedLocationIds, locationId];
      }
    } else {
      this.tempSelectedLocationIds = this.tempSelectedLocationIds.filter(id => id !== locationId);
    }
    this.allLocationsSelected = this.tempSelectedLocationIds.length === this.allLocations.length;
  }

  getFilteredLocations() {
    if (!this.locationSearchTerm || this.locationSearchTerm.trim() === '') {
      return this.allLocations || [];
    }
    const searchLower = this.locationSearchTerm.toLowerCase().trim();
    return (this.allLocations || []).filter(location =>
      location.name.toLowerCase().includes(searchLower)
    );
  }

  applyLocationFilter() {
    this.selectedLocationIds = [...this.tempSelectedLocationIds];
    this.allLocationsSelected = this.selectedLocationIds.length === this.allLocations.length;
    this.calculateMagnetsCount();
    this.groupData();
    this.closeLocationFilterDropdown();
  }

  private closeLocationFilterDropdown() {
    if (this.locationFilterDropdown?.nativeElement) {
      const dropdownElement = this.locationFilterDropdown.nativeElement;
      const bootstrap = (window as any).bootstrap;
      if (bootstrap && bootstrap.Dropdown) {
        const dropdownInstance = bootstrap.Dropdown.getInstance(dropdownElement);
        if (dropdownInstance) {
          dropdownInstance.hide();
          return;
        }
      }
      dropdownElement.classList.remove('show');
      dropdownElement.setAttribute('aria-expanded', 'false');
      const menu = dropdownElement.nextElementSibling as HTMLElement;
      if (menu) {
        menu.classList.remove('show');
      }
    }
  }

  toggleAllStatuses(selected: boolean) {
    this.allStatusesSelected = selected;
    if (selected) {
      this.tempSelectedStatuses = this.statusOptions
        .filter(s => s.value !== 'all')
        .map(s => s.value);
    } else {
      this.tempSelectedStatuses = [];
    }
  }

  toggleStatusSelection(status: string, selected: boolean) {
    if (status === 'all') return;
    if (selected) {
      if (!this.tempSelectedStatuses.includes(status)) {
        this.tempSelectedStatuses = [...this.tempSelectedStatuses, status];
      }
    } else {
      this.tempSelectedStatuses = this.tempSelectedStatuses.filter(s => s !== status);
    }
    const allStatusValues = this.statusOptions.filter(s => s.value !== 'all').map(s => s.value);
    this.allStatusesSelected = this.tempSelectedStatuses.length === allStatusValues.length;
  }

  applyStatusFilter() {
    this.selectedStatuses = [...this.tempSelectedStatuses];
    this.allStatusesSelected = this.selectedStatuses.length === this.statusOptions.filter(s => s.value !== 'all').length;
    this.groupData();
    this.closeStatusFilterDropdown();
  }

  private closeStatusFilterDropdown() {
    if (this.statusFilterDropdown?.nativeElement) {
      const dropdownElement = this.statusFilterDropdown.nativeElement;
      const bootstrap = (window as any).bootstrap;
      if (bootstrap && bootstrap.Dropdown) {
        const dropdownInstance = bootstrap.Dropdown.getInstance(dropdownElement);
        if (dropdownInstance) {
          dropdownInstance.hide();
          return;
        }
      }
      dropdownElement.classList.remove('show');
      dropdownElement.setAttribute('aria-expanded', 'false');
      const menu = dropdownElement.nextElementSibling as HTMLElement;
      if (menu) {
        menu.classList.remove('show');
      }
    }
  }

  getStatusFilterLabel(): string {
    if (this.allStatusesSelected || this.selectedStatuses.length === 0) {
      return 'All';
    }
    return `${this.selectedStatuses.length} selected`;
  }

  private matchesStatusFilter(birthday: any): boolean {
    if (this.allStatusesSelected || this.selectedStatuses.length === 0) {
      return true;
    }

    const orderStatus = birthday.orderStatus;
    const statusToOrderStatuses: { [key: string]: string[] } = {
      personalized: ['pending', 'in_progress', 'ready_to_ship', 'order_completed'],
      reserved: ['waiting_confirmation'],
      generic: ['generic_magnet'],
      cancelled: ['cancelled']
    };

    return this.selectedStatuses.some(s => statusToOrderStatuses[s]?.includes(orderStatus));
  }

  hasVisibleBirthdays(): boolean {
    if (!this.groupedData || this.groupedData.length === 0) return false;
    return this.groupedData.some((group: any) =>
      Array.isArray(group.locations) && group.locations.some((loc: any) =>
        Array.isArray(loc.birthdays) && loc.birthdays.length > 0
      )
    );
  }

  hasVisibleBirthdaysInDateGroup(dateGroup: any): boolean {
    if (!dateGroup || !Array.isArray(dateGroup.locations)) return false;
    return dateGroup.locations.some((loc: any) =>
      Array.isArray(loc.birthdays) && loc.birthdays.length > 0
    );
  }

  totalCelebrantMagnets: number = 0;
  totalReturnGiftMagnets: number = 0;

  // Country ISO filter state (e.g. mkd, uae, srb)
  selectedIso: string = 'all';
  isoOptions: { value: string; label: string }[] = [
    { value: 'all', label: 'All countries' },
    { value: 'mk', label: 'MK' },
    { value: 'ae', label: 'AE' },
    { value: 'rs', label: 'RS' },
    { value: 'hr', label: 'HR' },
    { value: 'ba', label: 'BA' },
  ];

  private getFilteredPlaygrounds(): Playground[] {
    if (!this.allLocationsSelected && this.selectedLocationIds.length > 0) {
      const filteredPlaygroundIds = new Set(
        this.allLocations
          .filter(loc => this.selectedLocationIds.includes(loc.id))
          .map(loc => loc.playgroundId)
      );
      return this.managedPlaygrounds.filter(p => filteredPlaygroundIds.has(p.uid));
    }
    return this.managedPlaygrounds;
  }

  calculateMagnetsCount(): void {
    const playgrounds = this.getFilteredPlaygrounds();

    this.totalCelebrantMagnets = playgrounds.reduce((sum, p) =>
      sum + Math.max(0, p['magnetsInStockCelebrant'] || 0), 0
    );

    this.totalReturnGiftMagnets = playgrounds.reduce((sum, p) =>
      sum + Math.max(0, p['magnetsInStockReturnGift'] || 0), 0
    );
  }

  hasMagnetsProperties(): boolean {
    if (!this.managedPlaygrounds?.length) {
      return false;
    }

    const playgrounds = this.getFilteredPlaygrounds();

    return playgrounds.some(p =>
      p['magnetsInStockCelebrant'] !== undefined ||
      p['magnetsInStockReturnGift'] !== undefined
    );
  }

  /**
   * Get the playground's country ISO from user_clients (managedPlaygrounds).
   * Used for filtering by country; not from appointment or location.
   */
  private getPlaygroundIso(playgroundId: string): string {
    const playground = this.managedPlaygrounds?.find(p => p.uid === playgroundId);
    if (!playground) return '';
    const raw =
      playground['countryCode'] ??
      '';
    return String(raw).toLowerCase().trim();
  }

  onIsoChange(iso: string) {
    this.selectedIso = iso;
    this.groupData();
  }

  getMagnetsLabel(): string {
    const userRole = localStorage.getItem('userRole');

    if (userRole === 'user' || this.managedPlaygrounds.length <= 1) {
      return '';
    }

    if (this.selectedLocationIds.length === 0) {
      return this.allLocationsSelected ? 'All: ' : 'Selected playgrounds: ';
    }

    const allSelected = this.selectedLocationIds.length === this.allLocations?.length;

    if (allSelected) {
      return 'All: ';
    }

    return 'Selected playgrounds: ';
  }

  onGeneratePaymentLink() {}
  copyPaymentLink(link: string) {}
}
